import { MdOutlineEmail } from 'react-icons/md';
import { InfoBanner } from '@ui';
import { SUPPORT_EMAIL } from './utils';

export const ShortWindowBanner = () => (
  <div className="ml-[28%] max-w-[72%]">
    <div className="flex items-center">
      <InfoBanner iconType="info">
        <div className="flex items-center justify-between">
          <span className="max-w-[95%]">
            Due to the short window before OR time please contact TMDX support team to create this case.
          </span>
          <span>
            <a href={`mailto:${SUPPORT_EMAIL}`}>
              <MdOutlineEmail size={20} />
            </a>
          </span>
        </div>
      </InfoBanner>
    </div>
  </div>
);
